<app-alerts />

<div
  (dragleave)="handleDragleave()"
  (dragover)="handleDragover()"
  (drop)="handleDragdrop()"
  [class.upload--disabled]="disabled()"
  [class.upload--dragover]="dragover()"
  [class.upload--pending]="pending()"
  class="relative">
  @if (dropzoneTemplateRef(); as templateRef) {
    <ng-container
      [ngTemplateOutlet]="templateRef"
      [ngTemplateOutletContext]="{
        maxFileSize: maxFileSize(),
        maxNumberOfFiles: maxNumberOfFiles(),
        pending: pending(),
      }" />
  } @else {
    <div class="relative">
      <app-upload-dropzone
        [maxFileSize]="maxFileSize()"
        [maxNumberOfFiles]="maxNumberOfFiles()" />

      @if (pending()) {
        <div class="absolute bottom-0 w-full">
          <app-progress-bar />
        </div>
      }
    </div>
  }

  <input
    #fileInput
    (change)="handleChange($event)"
    [attr.accept]="allowedMimeTypes()"
    [attr.multiple]="multiple()"
    class="absolute inset-0 cursor-pointer opacity-0"
    title=""
    type="file" />
</div>
